import { ArrowUpCircleIcon, CheckCircleIcon, CloudArrowUpIcon } from "@heroicons/react/24/solid";
import { useSpring, animated } from "@react-spring/web";
import { useEffect, useState } from "react";

import "./styles/savingIndicator.sass";

interface IProps {
    status: "SAVING" | "SAVED" | "SYNCING" | "SYNCED" | false;
}

const SavingIndicator = ({ status }: IProps) => {
    const [content, setContent] = useState({
        icon: <CloudArrowUpIcon />,
        text: "Waiting for action",
        style: "",
    });
    const [isOpen, setIsOpen] = useState(false);
    console.log(status)
    const generateContent = () => {
        let res;
        switch (status) {
            case "SYNCING":
                res = {
                    icon: <ArrowUpCircleIcon />,
                    text: "Syncing app",
                    style: "saving"
                }
                break;
            case "SYNCED":
                res = {
                    icon: <CheckCircleIcon />,
                    text: "Synced!",
                    style: "saved"
                }
                break;
            case "SAVING":
                res = {
                    icon: <CloudArrowUpIcon />,
                    text: "Saving...",
                    style: "saving",
                };
                break;
            case "SAVED":
                res = {
                    icon: <CheckCircleIcon />,
                    text: "Saved !",
                    style: "saved",
                };
                break;
            default:
                res = {
                    icon: <CheckCircleIcon />,
                    text: "Doing something",
                    style: "hidden",
                };
                break;
        }
        setContent(res);
    };

    const props = useSpring({
        x: isOpen ? window.innerWidth - 150 : window.innerWidth,
    });

    const close = () => {
        setIsOpen(false);
    };
    setTimeout(() => {
        if (status == "SAVED" || status === "SYNCED") close();
    }, 6000);
    useEffect(() => {
        generateContent();
        setIsOpen(true);
    }, [status]);

    return (
        <animated.div
            style={props}
            className={`indicator__wrapper indicator__wrapper-${content.style}`}
            onClick={close}
        >
            <span
                className={`indicator__content indicator__content-${content.style}`}
            >
                <div className="icon indicator__content__icon">
                    {content.icon}
                </div>
                {content.text}
            </span>
        </animated.div>
    );
};
export default SavingIndicator;
